import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useCheckPathname = () => {
  const location = useLocation();
  const pageName = location.pathname;
  useEffect(() => {
    const assignClass = (classNameStr) => {
      if (document.body.classList.contains("has-scroller")) {
        document.body.className = "has-scroller";
      } else {
        document.body.className = "";
      }

      document.body.classList.add(classNameStr);
    };

    if (pageName === "/") {
      assignClass("landing-body");
    } else if (pageName === "/videos") {
      assignClass("video-body");
    } else if (pageName === "/games") {
      assignClass("games-body");
    } else if (pageName === "/recipes") {
      assignClass("recipes-body");
    } else if (pageName === "/inner-tents") {
      assignClass("landing-body");
    } else if (pageName === "/about-us") {
      assignClass("about-body");
    } else {
      assignClass("not-found-body");
    }
  }, [pageName]);
};

export default useCheckPathname;
